import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';
import { getAccessLinkRoute } from '@confluence/ssr-app/entry-points/routes.ts';

import { ContentExtensionsProvider } from '../../ContentExtensionsProvider/index.ts';

export const AccessLinkRoute = getAccessLinkRoute({
	ContextProvider: ContentExtensionsProvider,
	NotFound,
});
